module.exports = __webpack_public_path__ + "images/74b71c86aa138dc45a5722f844805b4b.svg";